import { Component, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { environment } from '@env/environment'
import { MatomoTracker } from 'ngx-matomo-client'

@Component({
  standalone: true,
  selector: 'app-dialog-cookies',
  templateUrl: './dialog-cookies.component.html',
  imports: [
    // Material
    MatDialogModule,
    MatButtonModule,
  ],
})
export class DialogCookiesComponent {
  private readonly _dialogRef = inject(MatDialogRef<DialogCookiesComponent>)
  private readonly _data = inject(MAT_DIALOG_DATA) as { cookiesVersion: string }
  private readonly _tracker = inject(MatomoTracker)
  appName = environment.appName

  close() {
    this._dialogRef.close(false)
    localStorage.setItem('cookiesAccepted', this._data.cookiesVersion)
    // Check if tracking enabled
    const tracking = localStorage.getItem('trackingCookiesAccepted')
    if (tracking && JSON.parse(tracking)) {
      this._tracker.setConsentGiven()
    }
  }

  handleDeclineStatisticsCookies() {
    localStorage.setItem('trackingCookiesAccepted', JSON.stringify(false))
    this.close()
  }

  handleAcceptAllCookies() {
    localStorage.setItem('trackingCookiesAccepted', JSON.stringify(true))
    this.close()
  }
}
